import {initializePaddle} from '@paddle/paddle-js';
import ReactGA from 'react-ga4';
import wsManagerUtil from './utils/ws-manager-util';
import isOrganicUtil from './utils/is-organic-util';
import config from './constants/config';
if(isOrganicUtil()){
    if(config.GA4_ID){
        ReactGA.initialize(config.GA4_ID);
    }
    wsManagerUtil.connect();
    if(config.PADDLE_CLIENT_SIDE_TOKEN){
        initializePaddle({
            token:config.PADDLE_CLIENT_SIDE_TOKEN,
            pwCustomer:{},
        }).then(()=>{
            console.log('Paddle JS loaded!');
            if(config.PADDLE_IS_TESTING){
                Paddle.Environment.set('sandbox');
            }
        });
    }
}
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './components/app/app';
createRoot(document.getElementById('app')).render(<App/>);

